import StudentGuidanceInsertModal from "./StudentGuidanceInsertModal";

export default StudentGuidanceInsertModal;

